<video
  [webrtc-src]="webrtcPreviewData"
  poster="'/assets/stream-preview-loader.gif'"
></video>
<div
  class="availability-zones"
  *ngIf="availabilityZones && availabilityZones.length > 0"
>
  <div
    class="btn"
    *ngFor="let az of availabilityZones"
    (click)="setSelectedAz(az)"
    [class.selected]="selectedAvailabilityZoneId === az"
  >
    {{ liveFeedPreview.availabilityZoneUrls[az.toString()].displayName }}
  </div>
</div>
